import { BaseParameterDto } from '../../../../_models/base-parameter-dto';

export class BatchParametersDto extends BaseParameterDto {
    managementCompanyID: number;
    communityID: number;
    batchID: number;
    type: string;

    getQueryString(): string {
        const tokens = [];
        tokens.push(`managementCompanyID=${this.managementCompanyID}`);
        if (!!this.communityID) {
            tokens.push(`communityID=${this.communityID}`);
        }
        if (!!this.batchID) {
            tokens.push(`batchID=${this.batchID}`);
        }
        if (!!this.type) {
            tokens.push(`type=${this.type}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);

        return `?${tokens.join('&')}`;
    }
}
